<template>
  <div>{{ !shipping[checkpoint + '_place_id'] }}
    <b-tabs v-model="addressTypesTab">
      <b-tab :title="$gettext('By GeoFence')" v-if="ecosystemModules.geofences">
        <b-form-row>
          <div class="form-group col my-3">
            <label for="checkpoint-geofence" v-translate>Type to search</label>
            <geofence-autocomplete id="checkpoint-geofence" :restrict-to-levels="[0]" :includes="['geo_type', 'geo_fences.geo_type', 'geo_lines.geo_type', 'geo_points.geo_type']" @selected="selectedGeoFence" />
          </div>
        </b-form-row>
      </b-tab>
      <b-tab :title="$gettext('By Address')">
        <b-form-row>
          <div class="form-group col-sm-8 my-3">
            <label for="from_extra" v-translate>Street and number</label>
            <div class="input-group" v-if="!shipping[checkpoint + '_place_id']">
              <address-autocomplete ref="addressAutocomplete" @selected="selected" :min-character="6" static-items />
              <div v-if="shipping.fields_revision_data && shipping.fields_revision_data[checkpoint] && typeof shipping.fields_revision_data[checkpoint] === 'string'" class="text-danger">{{ shipping.fields_revision_data[checkpoint] }}</div>
            </div>
            <p v-if="shipping['address_' + checkpoint]?.formatted_address">
              {{ shipping['address_' + checkpoint].formatted_address }}
              <b-badge variant="danger" href="#" @click.prevent="resetPlace">×</b-badge>
            </p>
          </div>
          <div class="form-group col-sm-4 my-3">
            <label for="destination-floor" v-translate>Floor, door, etc.</label>
            <div class="input-group">
              <b-form-input id="destination-floor" v-model="shipping[checkpoint + '_extra']" />
            </div>
          </div>
        </b-form-row>
      </b-tab>
    </b-tabs>
    <div v-if="ecosystemModules.geofences && shipping[metaType] && shipping[metaType].geofences && shipping[metaType].geofences[checkpoint] && shipping[metaType].geofences[checkpoint].external_id">
      <p class="m-0" v-translate>Selected GeoFence</p>
      <h4><geofence-title :geofence="shipping[metaType].geofences[checkpoint]" /></h4>
    </div>
    <div v-if="ecosystemConfig && ecosystemConfig.extraCheckpoints && ecosystemConfig.extraCheckpoints['before' + extraCheckpointsEvent] && shipping[metaType]">
      <b-form-row v-if="!shipping[metaType].extraCheckpoints || !shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent] || shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent].length === 0">
        <b-col class="text-center mb-4">
          <b-button v-b-modal="'modalPickEntrancePlace' + checkpoint" :disabled="!shipping['address_' + checkpoint].lat" v-if="shipping[metaType].geofences && shipping[metaType].geofences[checkpoint] && shipping[metaType].geofences[checkpoint].id" v-translate>Select Place Extra Data</b-button>
          <b-modal size="xl" :id="'modalPickEntrancePlace' + checkpoint" :ref="'modalPickEntrancePlace' + checkpoint" hide-footer hide-header>
            <geodata-picker ref="pickEntrancePlaceMap" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @selectedElements="setExtraCheckpointsSelectedElements" centerMap fit-always :zoom="17" height="500px" />
          </b-modal>
          <b-button v-b-modal="'modalPickEntryPoint' + checkpoint" :disabled="!shipping['address_' + checkpoint].lat" v-if="!shipping[metaType].geofences || !shipping[metaType].geofences[checkpoint] || !shipping[metaType].geofences[checkpoint].id" v-translate>Pick Single Entry point</b-button>
          <b-modal size="xl" :id="'modalPickEntryPoint' + checkpoint" :ref="'modalPickEntryPoint' + checkpoint" hide-footer hide-header>
            <place-picker ref="pickEntrancePlaceMap" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @placePicked="setEntrancePlacePicked" centerMap fit-always :zoom="17" height="500px" />
          </b-modal>
        </b-col>
      </b-form-row>
      <b-form-row v-else>
        <b-card>
          <h5>
            <translate>Place Extra Data</translate>
            <b-button size="sm" variant="warning" v-b-modal="'modalPickEntrancePlace' + checkpoint" v-if="shipping[metaType].extraCheckpoints && shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent] && shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent].filter(x => x.dupe).length > 0">
              <font-awesome-icon icon="clipboard-list" />
            </b-button>
          </h5>
          <b-modal size="xl" :id="'modalPickEntrancePlace' + checkpoint" :ref="'modalPickEntrancePlace' + checkpoint" hide-footer hide-header>
            <place-picker v-if="!ecosystemModules.geofences" ref="pickEntrancePlaceMap" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @placePicked="setEntrancePlacePicked" centerMap fit-always :zoom="17" height="500px" />
            <geodata-picker v-else ref="pickEntrancePlaceMap" :parent-data="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent]" @ready="setEntrancePlaceCenter" @cancel="closeModalPickEntrancePlace" @selectedElements="setExtraCheckpointsSelectedElements" centerMap fit-always :zoom="17" height="500px" />
          </b-modal>
          <span class="bg-danger text-white d-block text-center" style="cursor: pointer; width: 1rem; height: 1rem; line-height: 1rem; position: absolute; top: 0; left: 0" href="#" @click.prevent="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent] = []">×</span>
          <p v-if="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place" class="m-0">
            <b-button size="sm" @click.stop="openMapOn(shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.formatted_address + '/@' + shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lat + ',' + shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lng + ',17z')" class="py-0 px-1" :title="$gettext('Quick view address map on new window')">
              <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 10px; vertical-align: middle;" />
            </b-button>
            {{shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.formatted_address}}
            <em>
              ({{shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lat}}, {{shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].place.lng}})
            </em>
          </p>
          <b-list-group v-if="shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent][0].geo_type_id">
            <b-list-group-item v-for="(element, index) in shipping[metaType].extraCheckpoints['before' + extraCheckpointsEvent]" :key="'beforePickup' + index" class="p-2">
              <span v-if="element.dupe">
                <font-awesome-icon icon="exclamation-triangle" class="text-warning" />
              </span>
              <strong>{{element.external_id}}</strong> {{ element.name }} <small>[{{ element.geo_type ? element.geo_type.name : geoTypes.find(x => x.id === element.geo_type_id).name }}]</small>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-form-row>
    </div>

    <b-modal size="lg" id="modalPickPlace" ref="modalPickPlace" hide-footer hide-header>
      <place-picker ref="pickPlaceMap" :hasReference="checkpoint === 'from'" @cancel="closeModalPickPlace" @placePicked="setPlacePicked" centerMap fit-always :zoom="17" />
    </b-modal>

  </div>
</template>

<script>
import AddressesMixin from '@/mixins/address.mixin'
import ShippingsMixin from '@/mixins/shippings.mixin'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import PlacePicker from '@/components/PlacePicker'
import GeodataPicker from '@/components/GeodataPicker'
import GeofenceAutocomplete from '@/components/Autocompletes/GeofenceAutocomplete'
export default {
  name: 'CompanyNewShipping',
  components: {
    AddressAutocomplete,
    PlacePicker,
    GeodataPicker,
    GeofenceAutocomplete
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    },
    checkpoint: {
      type: String,
      default: 'from'
    },
    metaType: { // TODO: abstract the component for use with B2B API and normal API
      type: String,
      default: 'conf'
    }
  },
  data() {
    return {
      extraCheckpointsEvent: 'Pickup',
      markers: [],
      addressTypesTab: 0
    }
  },
  mixins: [
    AddressesMixin,
    ShippingsMixin
  ],
  mounted() {
    this.extraCheckpointsEvent = this.checkpoint === 'to' ? 'Delivery' : this.extraCheckpointsEvent
    this.$nextTick(() => {
      this.addressTypesTab = this.ecosystemModules.geofences && this.shipping[this.metaType] && this.shipping[this.metaType].geofences && this.shipping[this.metaType].geofences[this.checkpoint] && this.shipping[this.metaType].geofences[this.checkpoint].external_id ? 0 : 1
    })
  },
  methods: {
    async selectedGeoFence(item) {
      let cleanupDupes = item.fence && item.fence.coordinates ? [Array.from(new Set(item.fence.coordinates[0].map(a => a.join('|'))), s => s.split('|').map(Number))] : null
      item.fence = cleanupDupes ? cleanupDupes.map(x => {
        return x.map(y => [y[1], y[0]])
      })[0] : item.fence

      let coords = this.getCenter(item.fence)

      await this.checkPlaceByCoords(coords[0], coords[1])
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.setPlacePicked(this.theCheckedAddress)
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = [
              this.theCheckedAddress.lat,
              this.theCheckedAddress.lng
            ]
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })

      this.shipping[this.metaType] = {...this.shipping[this.metaType], geofences: {...this.shipping[this.metaType].geofences, [this.checkpoint]: item}}
      this.shipping[this.metaType] = {...this.shipping[this.metaType], extraCheckpoints: {...this.shipping[this.metaType].extraCheckpoints, ['before' + this.extraCheckpointsEvent]: this.checkForAutoExtraCheckpoints(item)}}

      this.shipping['address_' + this.checkpoint].formatted_address = this.shipping['address_' + this.checkpoint].addressDescription = this.theCheckedAddress.formatted_address
      this.shipping[this.checkpoint + '_contact'] = item.external_id + ' - ' + item.name
    },
    setPlacePicked(place) {
      this.shipping[this.checkpoint + '_place_id'] = place.id
      this.shipping['address_' + this.checkpoint].formatted_address = place.formatted_address
      this.shipping['address_' + this.checkpoint].lat = place.lat
      this.shipping['address_' + this.checkpoint].lng = place.lng
      this.shipping['address_' + this.checkpoint].addressDescription = place.formatted_address

      this.$refs.modalPickPlace.hide()
      this.emitPlaceSelected([place.lat, place.lng])
    },
    closeModalPickPlace() {
      this.$refs.modalPickPlace.hide()
    },
    async selected(item) {
      if (item.reference) {
        this.shipping[this.checkpoint + '_contact'] = item.contact
        this.shipping[this.checkpoint + '_email'] = item.email
        this.shipping[this.checkpoint + '_phone'] = item.phone
      }
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.setPlacePicked(this.theCheckedAddress)
        } else if (this.theCheckedAddress.validAddress === false) {
          this.$refs.modalPickPlace.show()
          setTimeout(function () {
            this.$refs.pickPlaceMap.center = [
              this.theCheckedAddress.lat,
              this.theCheckedAddress.lng
            ]
            this.$refs.pickPlaceMap.styles = 'height: 500px;'
          }.bind(this), 100)
        }
      })
      this.shipping['address_' + this.checkpoint].formatted_address = this.formattedDisplay(item)
      this.shipping[this.metaType] = {...this.shipping[this.metaType], extraCheckpoints: {...this.shipping[this.metaType].extraCheckpoints, ['before' + this.extraCheckpointsEvent]: []}}
      if (this.ecosystemModules.geofences) {
        this.shipping[this.metaType] = {...this.shipping[this.metaType], geofences: {...this.shipping[this.metaType].geofences, [this.checkpoint]: {}}}
      }
    },
    setEntrancePlacePicked(place) {
      delete place.raw
      this.shipping[this.metaType] = {...this.shipping[this.metaType], extraCheckpoints: {...this.shipping[this.metaType].extraCheckpoints, ['before' + this.extraCheckpointsEvent]: [{place, order: 0}]}}

      this.closeModalPickEntrancePlace()
    },
    setExtraCheckpointsSelectedElements(elements) {
      // FIXME: for now we store the complete data of each element, look on next TODO
      this.shipping[this.metaType].extraCheckpoints['before' + this.extraCheckpointsEvent] = elements.map(x => {
        if (x.originalFence) {
          x.fence = x.originalFence
          delete x.coordinates
          delete x.originalFence
        }
        if (x.originalPath) {
          x.path = x.originalPath
          delete x.coordinates
          delete x.originalPath
        }
        return x
      })
      // TODO: store just ID and type and make all needed requests to gather the elements data
      // .map(x => {
      //   return {
      //     id: x.id,
      //     type: x.type
      //   }
      // })

      this.closeModalPickEntrancePlace()
    },
    setEntrancePlaceCenter() {
      this.$refs.pickEntrancePlaceMap.center = [(this.shipping['address_' + this.checkpoint].lat || this.shipping[this.checkpoint].coords.lat), (this.shipping['address_' + this.checkpoint].lng || this.shipping[this.checkpoint].coords.lng)]
      this.$refs.pickEntrancePlaceMap.markers[0] = this.$refs.pickEntrancePlaceMap.transformMarker({
        id: '0',
        lat: (this.shipping['address_' + this.checkpoint].lat || this.shipping['address_' + this.checkpoint].coords.lat),
        lng: (this.shipping['address_' + this.checkpoint].lng || this.shipping['address_' + this.checkpoint].coords.lng),
        icon: {
          type: this.ecosystemModules.items.icon.type,
          size: this.ecosystemModules.items.icon.size,
          anchor: this.ecosystemModules.items.icon.anchor,
          color: '#000',
          text: this.ecosystemModules.items.icon.text
        }})
    },
    closeModalPickEntrancePlace() {
      this.$refs['modalPickEntrancePlace' + this.checkpoint].hide()
    },
    formattedDisplay(result) {
      return result.main_text + ', ' + result.secondary_text
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    resetPlace() {
      this.shipping['address_' + this.checkpoint].formatted_address = ''
      this.shipping[this.checkpoint + '_place_id'] = null
    },
    getCenter(coordinates) {
      return coordinates.reduce(function (x, y) {
        return [x[0] + y[0] / coordinates.length, x[1] + y[1] / coordinates.length]
      }, [0, 0])
    },
    emitPlaceSelected(coords) {
      this.$emit('place-selected', coords, this.checkpoint)
    }
  }
}
</script>
